import React from 'react';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Chip,
  Tooltip,
} from '@material-ui/core';
import { DeploymentStatus } from '../types';

interface KubernetesDeploymentCardProps {
  deployments: DeploymentStatus[];
  loading?: boolean;
}

function getReplicaColor(ready: number, total: number): string {
  if (total === 0) return '#9e9e9e';
  if (ready === total) return '#4caf50';
  if (ready > 0) return '#ff9800';
  return '#f44336';
}

function getImageTag(image: string): string {
  const parts = image.split(':');
  return parts.length > 1 ? parts[parts.length - 1] : image.split('/').pop() || image;
}

export const KubernetesDeploymentCard: React.FC<KubernetesDeploymentCardProps> = ({
  deployments,
  loading,
}) => {
  return (
    <Card>
      <CardHeader
        title={`Deployments (${deployments.length})`}
        titleTypographyProps={{ variant: 'subtitle1', style: { fontWeight: 600 } }}
        style={{ paddingBottom: 0 }}
      />
      <CardContent style={{ padding: 0 }}>
        {loading ? (
          <Box p={2}>
            <Typography variant="body2" color="textSecondary">加载中...</Typography>
          </Box>
        ) : deployments.length === 0 ? (
          <Box p={2}>
            <Typography variant="body2" color="textSecondary">暂无 Deployment</Typography>
          </Box>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>名称</TableCell>
                <TableCell style={{ width: 90 }}>副本</TableCell>
                <TableCell style={{ width: 130 }}>镜像版本</TableCell>
                <TableCell style={{ width: 110 }}>策略</TableCell>
                <TableCell style={{ width: 80 }}>运行时长</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {deployments.map(d => {
                const color = getReplicaColor(d.readyReplicas, d.replicas);
                const tag = getImageTag(d.image);
                return (
                  <TableRow key={d.name} hover>
                    <TableCell>
                      <Typography variant="body2" style={{ fontSize: '0.8rem', fontFamily: 'monospace' }}>
                        {d.name}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={`${d.readyReplicas}/${d.replicas}`}
                        size="small"
                        style={{
                          backgroundColor: color + '22',
                          color,
                          border: `1px solid ${color}44`,
                          fontWeight: 600,
                          fontSize: '0.75rem',
                          height: 20,
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Tooltip title={d.image}>
                        <Typography
                          variant="body2"
                          style={{
                            fontSize: '0.8rem',
                            fontFamily: 'monospace',
                            color: '#555',
                            maxWidth: 120,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {tag}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" style={{ fontSize: '0.8rem', color: '#666' }}>
                        {d.strategy}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" style={{ fontSize: '0.8rem', color: '#888' }}>
                        {d.age}
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};
